import {WindowEventListenerRegistration} from "./window-event-listener-registration";
import {NullableString} from "../../types/nullable-types";

export enum WellKnownQueryParams {
    Lang = "lang",
    Culture = "culture",
    Agent = "agent",
    OriginalAgent = "originalAgent",
    OriginStation = "o1",
    DestinationStation = "d1",
    DepartureDate = "dd1",
    ReturnDate = "dd2",
    IsRoundTripFlight = "r",
    SpecialPriceUserOption = "spuo",
    SpecialPriceUserAgreement = "spua",
    BookingCurrency = "bc"
}

export interface IWindowService {
    readonly subscribeTo: WindowEventListenerRegistration;
    getGlobalProperty<T = any>(name: string): T;
    setGlobalProperty(name: string, value: any): void;
    getOrigin(): string;
    redirect(url: string): void;
    getUrlParam(paramName: string): NullableString;
    postMessage(message: any): void;
    readonly searchParams: URLSearchParams;
    readonly origin: string;
    goBack(): void;

}
